export const reportsStudentsListIntroSteps = (isDistrict: boolean = false) => [
  {
    element: '#help-tour-btn',
    intro: 'Click here to take a tour of this page.'
  },
  {
    element: '#schoolFilter',
    intro: 'Select a school from the dropdown to view the student list for the selected school(s).'
  },
  {
    element: '#teacherFilter',
    intro: 'Select a teacher from the dropdown to view the student list for that teacher.'
  },
  {
    element: '#export-button',
    intro: isDistrict
      ? 'Click here to export the student list for the selected school and teacher.'
      : 'Click here to export the student list for the selected teacher.',
  },
  {
    element: '#print-button',
    intro: isDistrict
      ? 'Click here to print the student list for the selected school and teacher.'
      : 'Click here to print the student list for the selected teacher.'
  },
  {
    element: '.search-bar',
    intro: 'Click here to search for a specific student name.'
  },
  {
    element: '#report-table-header',
    intro: isDistrict
      ? 'Scroll to view the student list for the selected school and teacher.'
      : 'Scroll to view the student list for the selected teacher.'
  }
];
